import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { I as IconProfile } from '../index-1707f584.js';
import { Icon } from './icon.js';

var styles = {
raw: ".hcr-avatar-1-6-0{display:block;width:36px;height:36px}.hcr-avatar__image-1-6-0{width:100%;height:100%;border-radius:100%}.hcr-avatar__image-1-6-0 svg{width:100%;height:100%}.hcr-avatar--sm-1-6-0{width:24px;height:24px}.hcr-avatar--lg-1-6-0{width:48px;height:48px}.hcr-avatar--xl-1-6-0{width:96px;height:96px}",
map:{"hcr-avatar":"hcr-avatar-1-6-0","hcr-avatar__image":"hcr-avatar__image-1-6-0","hcr-avatar--sm":"hcr-avatar--sm-1-6-0","hcr-avatar--lg":"hcr-avatar--lg-1-6-0","hcr-avatar--xl":"hcr-avatar--xl-1-6-0"}};

var bem = Bem('avatar', styles);
var Avatar = function Avatar(_ref) {
  var alt = _ref.alt,
      as = _ref.as,
      children = _ref.children,
      extraClasses = _ref.extraClasses,
      size = _ref.size,
      src = _ref.src,
      url = _ref.url,
      rest = _objectWithoutProperties(_ref, ["alt", "as", "children", "extraClasses", "size", "src", "url"]);

  var avatarClassNames = bem.b([size], extraClasses); // if no url passed render as div (default element type)

  var WrapperElement = url ? 'a' : as;
  return React.createElement(WrapperElement, _extends({
    className: avatarClassNames,
    href: url
  }, rest), src && React.createElement("img", {
    className: bem.e('image'),
    src: src,
    alt: alt
  }), !src && children);
};
Avatar.displayName = 'Avatar';
Avatar.defaultProps = {
  alt: '',
  as: 'div',
  extraClasses: '',
  children: React.createElement(Icon, {
    InlineIcon: IconProfile,
    size: "cover"
  }),
  size: null,
  src: '',
  url: null
};
Avatar.propTypes = {
  /** image alt text */
  alt: PropTypes.string,

  /** pass a custom elementType, e.g. "div", or "span" or even react router's Link component from */
  as: PropTypes.elementType,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Custom content for avatar, use if you need something more sophisticated than an image,
   * like a component or inline SVG */
  children: PropTypes.node,

  /** Creates a Highlighted box */
  size: PropTypes.oneOf(['sm', 'lg', 'xl']),

  /** Url of the avatar image to show */
  src: PropTypes.string,

  /** Provide a url if you want the avatar to be a link */
  url: PropTypes.string
};
var Avatar$1 = Injecss(Avatar, styles);

export { Avatar$1 as Avatar };
